/* this file is transformed by vux-loader */
/* eslint-disable */
import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";

/*  axios封装 */
import Vue from 'vue';
import axios from 'axios';
import router from '@/router/index';
[_Toast, _Dialog].forEach(function (e) {
  Vue.use(e);
});
axios.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response && error.response.status == 301) {
    router.push({
      path: '/login'
    });
  } else {
    return Promise.reject({
      status: 'response_error',
      errmsg: '服务器异常，请稍后再试！'
    });
  }
});
var loadingCount = 0; // 请求loading加载的次数

Vue.prototype.$http = function (url, params) {
  var isLoading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var method = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'post';

  if (isLoading) {
    loadingCount++;

    var ToastAjax = _Toast.loading({
      duration: 0,
      // 持续展示
      forbidClick: true,
      message: '加载中...'
    });
  }

  function isCloseLoading() {
    loadingCount--;

    if (loadingCount <= 0 && isLoading && ToastAjax) {
      ToastAjax.clear();
      loadingCount = 0; // 重置计数
    }
  }

  params = params || {};
  return new Promise(function (resolve, reject) {
    axios({
      url: url,
      data: params,
      method: method
    }).then(function (res) {
      var _res$data;

      isCloseLoading();
      resolve(res === null || res === void 0 ? void 0 : res.data);

      if (!((_res$data = res.data) !== null && _res$data !== void 0 && _res$data.status)) {
        // 使用setTimeout确保loading关闭后再显示Dialog
        setTimeout(function () {
          _Dialog.alert({
            message: res.data.errmsg
          });
        }, 50);
        return;
      }
    }).catch(function (err) {
      isCloseLoading();
      setTimeout(function () {
        reject(err);
      }, 50);
    });
  });
};